module.exports = __webpack_public_path__ + "static/Formularz-Zgłoszeniowy-c52ccf75331cd0e587f219c02ccd7135.pdf";